import React, { useState, useEffect } from "react";
import ReactDOMServer from "react-dom/server";
import { connect } from "react-redux";
import { PayPalButton } from "react-paypal-button-v2";
import { dateFormat } from "../../lib/dateFormat";

import { auth, firestore } from "../../firebase";
import * as actions from "../../store/actions";

import Success from "./Success/Success";
import Error from "./Error/Error";
import Spinner from "../UI/Spinner/Spinner";

import classes from "./Purchase.module.css";

const Purchase = ({
  category,
  email,
  userId,
  purchased,
  onUpdatePurchased,
  onSetCurrentCategory,
}) => {
  const [tip, setTip] = useState(0);
  const [purchaseState, setPurhaseState] = useState("purchase");
  const [showPayPal, setShowPayPal] = useState(false);

  useEffect(() => {
    //  Fixes error when closing modal while loading PayPal
    //  Stupid, but it works
    const timer = () =>
      setTimeout(() => {
        setShowPayPal(true);
      }, 500);
    const timerId = timer();
    return () => {
      //  Clear timeout when unmounting component
      clearTimeout(timerId);
    };
  }, []);

  const onCreateOrder = (data, actions) => {
    setPurhaseState("loading");
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            currency_code: "USD",
            value: (category.price * 100 + parseFloat(tip) * 100) / 100,
          },
          description: `category: ${category.name}, tip: $${tip}`,
        },
      ],
      application_context: {
        shipping_preference: "NO_SHIPPING",
      },
    });
  };

  const onPurchase = (details, data) => {
    const newPurchased = [...purchased, category.name];
    onUpdatePurchased(newPurchased);
    setPurhaseState("success");

    // Add purchased category to user profile
    firestore
      .collection("users")
      .doc(userId)
      .update({ purchased: newPurchased });

    // Send e-mail to user
    const dateObject = new Date(details.create_time);
    const date = dateFormat(dateObject, "mmm d yyyy h:MM TT (Z)");

    const orderId = details.purchase_units[0].payments.captures[0].id;

    const emailHtml = (
      <>
        Thank you for purchasing the {category.name} premium category over at
        Art Prompts! You can now access all the prompts in the{" "}
        <a href="https://artprompts.app/web-app/app">web app</a>.<br />
        You have purchased this category on {date}. If you have any questions,
        please let us know at <strong>contact@artprompts.app</strong>. Your
        order ID is {orderId}.
        <br />
        <br />
        As a special thank you, we wanted to give you one bonus free prompt:{" "}
        <span style={{ fontStyle: "italic" }}>
          Draw the team behind Art Prompts admiring your art.
        </span>{" "}
        <br />
        <br />
        Happy drawing!
      </>
    );

    firestore
      .collection("mail")
      .doc()
      .set({
        to: email,
        message: {
          subject: `Order #${orderId} confirmed`,
          text: `Thank you for purchasing the ${category.name} premium category over at Art Prompts! You can now access all the prompts in the web app. You have purchased this category on ${date}. If you have any questions, please let us know at contact@artprompts.app. Your order number is ${orderId}. As a special thank you, we wanted to give you one bonus free prompt: Draw the team behind Art Prompts admiring your art. Happy drawing!`,
          html: ReactDOMServer.renderToStaticMarkup(emailHtml),
        },
      });

    // Set current category in Redux
    onSetCurrentCategory(category.name);
  };

  const onTipChange = (event) => {
    setTip(event.target.value);
  };

  const logout = () => {
    auth.signOut();
    onUpdatePurchased([]);
  };
  let PayPal = showPayPal ? (
    <PayPalButton
      createOrder={onCreateOrder}
      onSuccess={onPurchase}
      onCancel={() => setPurhaseState("purchase")}
      onError={() => setPurhaseState("error")}
      options={{
        clientId:
          "AXn7eemVm1hWWbVXsTpfH8ZSR3hWRE9kiM5TpRiSiBOMBmLV-BtI0tH4JqJF_76VXyLKPPa9Hh9qIp3p",
      }}
      style={{
        shape: "pill",
        layout: "horizontal",
        tagline: "false",
      }}
    />
  ) : null;

  let content = (
    <div>
      <h2>Purchase category</h2>
      <p>
        This is a one-time purchase; once you’re done, the category will stay
        unlocked on your account forever, and will include all the prompts that
        will be added in the future.
      </p>
      <p className={classes.Tip}>
        Care to give us a small tip for our hard work?
      </p>
      <div className={classes.RangeContainer}>
        <input
          className={classes.Range}
          type="range"
          min="0"
          max="4.99"
          step="0.01"
          value={tip}
          onChange={onTipChange}
        />
        <p>${tip}</p>
      </div>
      <div className={classes.Row}>
        <p>{category.name}</p>
        <p>${category.price}</p>
      </div>
      <div className={classes.Row}>
        <p>Tip</p>
        <p>${tip}</p>
      </div>
      <div className={classes.Row}>
        <p>
          <strong>Total</strong>
        </p>
        <p>
          <strong>
            ${(category.price * 100 + parseFloat(tip) * 100) / 100}
          </strong>
        </p>
      </div>
      <br />
      <div className={classes.Checkout}>
        {PayPal}
        <p>Pay via PayPal or credit card by clicking the button above</p>
      </div>
      <p style={{ marginBottom: 0, textAlign: "center" }}>
        You’re logged in as <strong>{email}</strong>
        <br />
        <button className={classes.Link} onClick={logout}>
          Log into another account?
        </button>
      </p>
    </div>
  );

  switch (purchaseState) {
    case "success":
      content = <Success name={category.name} />;
      break;
    case "error":
      content = <Error />;
      break;
    default:
      break;
  }

  return (
    <div className={classes.Purchase}>
      {content}
      {purchaseState === "loading" ? (
        <div className={classes.Loading}>
          <Spinner />
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  email: state.email,
  userId: state.userId,
  purchased: state.purchased,
});

const mapDispatchToProps = (dispatch) => ({
  onUpdatePurchased: (purchased) =>
    dispatch(actions.updatePurchased(purchased)),
  onSetCurrentCategory: (category) =>
    dispatch(actions.setCurrentCategory(category)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Purchase);
